import axios  from 'axios';
import { Config }   from './configActions';

export const FETCH_ALL_TIMELINE_HOME = 'FETCH_ALL_TIMELINE_HOME';

var Authorization = axios.defaults.headers.common['Authorization'] = 'Bearer '+localStorage.getItem("jwtToken");
Config();

export function GetTimeLineHome(tur_id) {
    
    const request = axios.get(`/api/timeline/listar/${tur_id}`, Authorization);
    return{
        type    : FETCH_ALL_TIMELINE_HOME,
        payload : request

    };
}


// WEBPACK FOOTER //
// ./src/actions/timelineAction.js